import { render, staticRenderFns } from "./AnalysisPlate.vue?vue&type=template&id=8d9177f0&scoped=true&"
import script from "./AnalysisPlate.vue?vue&type=script&lang=js&"
export * from "./AnalysisPlate.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisPlate.vue?vue&type=style&index=0&id=8d9177f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9177f0",
  null
  
)

export default component.exports